import { LocalFilterOptions } from 'src/components/organisms';
import { GlobalFilterLocation } from 'src/types';
import * as XLSX from 'xlsx';
import { DateFormats, formatDate } from '../time';
import { processData } from './processData';
import { CombinedProps } from './saveData.types';

export const createDataWorksheet = (
  data:
    | Record<string, string | number>[]
    | {
        type: string;
        count: number;
        group: number;
        group_name: string;
        color: string;
        letter_label: string;
      }[],
  props: Pick<CombinedProps, 'data' | 'title' | 'filters' | 'dataType'>,
  workbook: XLSX.WorkBook,
) => {
  let rows = data;

  const groupedBy = props.filters?.selectionFilter?.find(
    (filter) => filter.label === 'Group by',
  )?.value;

  if (props.dataType) {
    rows = processData(data, props.dataType, groupedBy);
  }

  const dataWorksheet = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, dataWorksheet, 'Data');
  dataWorksheet['!cols'] = new Array(Object.keys(rows[0]).length).map(() => ({
    wch: 30,
  }));
};

const arrayToString = (array: Array<string>) => {
  return array.join(', ');
};

export const createFiltersWorksheet = (
  selectionFilters: LocalFilterOptions,
  workbook: XLSX.WorkBook,
) => {
  let rows = [];
  const selectedLocation =
    selectionFilters.selectedLocationFilter ?? GlobalFilterLocation.SITES;
  if (
    selectionFilters.site &&
    selectedLocation === GlobalFilterLocation.SITES
  ) {
    rows.push({
      filter: 'sites',
      details: arrayToString(selectionFilters.site.selectedOptions),
    });
  }
  if (
    selectionFilters.country &&
    selectedLocation === GlobalFilterLocation.COUNTRIES
  ) {
    rows.push({
      filter: 'countries',
      details: arrayToString(selectionFilters.country.selectedOptions),
    });
  }
  if (selectionFilters.department) {
    rows.push({
      filter: 'departments',
      details: arrayToString(selectionFilters.department.selectedOptions),
    });
  }
  if (selectionFilters.category) {
    rows.push({
      filter: 'categories',
      details: arrayToString(selectionFilters.category.selectedOptions),
    });
  }
  if (selectionFilters.time) {
    rows.push({
      filter: 'timeframe',
      details: `${selectionFilters.time.timeframe.start} to ${selectionFilters.time.timeframe.end}`,
    });
  }
  rows.push({
    filter: 'downloaded at',
    details: formatDate(new Date(), DateFormats.DAY_MONTH_YEAR_TIME),
  });

  const filtersWorksheet = XLSX.utils.json_to_sheet(rows);

  XLSX.utils.book_append_sheet(workbook, filtersWorksheet, 'Filters');
  filtersWorksheet['!cols'] = [{ wch: 30 }, { wch: 50 }];
};
